import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    DataServiceError,
    DefaultDataServiceConfig,
    EntityActionFactory,
    EntityOp,
    HttpUrlGenerator
} from '@ngrx/data';
import { Update } from '@ngrx/entity';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as fromShared from '../../shared';
import { IGenericResponse, ResponseStatus } from '../../shared';
import { LoggingService } from '../../shared/services/logging';
import { EfaactDataService } from '../efaact.data-service';
import { InvoiceContractCycleModel } from './invoice-contract-cycle.model';

export const entityName = 'InvoiceContractCycle';
@Injectable({ providedIn: 'root' })
export class InvoiceContractCycleDataService extends EfaactDataService<InvoiceContractCycleModel> {
    mapItems(item: InvoiceContractCycleModel): InvoiceContractCycleModel {
        return {
            ...item,
            id: item.ContractInvoiceCycleID
        };
    }
    protected save(
        update: Update<InvoiceContractCycleModel>
    ): Observable<InvoiceContractCycleModel> {
        this.log.verbose({
            type: `${this.entityName}DataService(InvoiceContractCycleDataService):save`,
            update
        });
        const item = {
            ...update.changes
        } as InvoiceContractCycleModel;

        return this.http
            .put<IGenericResponse<InvoiceContractCycleModel>>(
                this.entitiesUrl,
                {
                    [`${this.entityName}List`]: [item]
                }
            )
            .pipe(
                // withLatestFrom(
                //     this.store.pipe(select(this.selectors.selectEntities))
                // ),
                map(
                    resp =>
                        ({
                            ...resp,
                            Items: resp.Items.map(item => ({
                                ...this.mapItems(item),
                                Status:
                                    item.Status.StatusCode === 0
                                        ? {
                                              Message: 'Updated',
                                              MsgEntityID:
                                                  item.ContractInvoiceCycleID,
                                              StatusCode: ResponseStatus.Success
                                          }
                                        : item.Status
                            }))
                        } as IGenericResponse<InvoiceContractCycleModel>)
                ),
                map(resp => {
                    // const InvoiceContractCycle = InvoiceContractCycles.find(x => x.id === update.id);
                    // if (!InvoiceContractCycle) {
                    //     return update.changes as InvoiceContractCycleModel;
                    // }
                    this.log.verbose({
                        type: `${this.entityName}DataService(InvoiceContractCycleDataService):save:resp`,
                        resp,
                        update
                    });
                    if (!fromShared.Errors.IsSuccessStatus(resp.StatusCode)) {
                        this.store.dispatch(
                            new fromShared.Errors.SetErrors(
                                fromShared.Errors.MapErrorsToStatus({
                                    ...resp,
                                    Items: resp.Items.filter(x => !!x).map(
                                        x => ({
                                            ...x,
                                            Status: {
                                                ...x.Status,
                                                MsgEntityID:
                                                    (update.changes.original &&
                                                        update.changes.original
                                                            .id) ||
                                                    update.changes.id
                                            }
                                        })
                                    )
                                })
                            )
                        );
                        // need to do this b/c the change of a checkbox is immediate and there is no cancel to put it back
                        // if something is wrong with the save
                        const af = new EntityActionFactory();
                        // if (update.changes.SyncPayrollItems === true) {
                        const action = af.create(
                            this.entityName,
                            EntityOp.SAVE_UPDATE_ONE_SUCCESS,
                            {
                                id: update.changes.id,
                                changed: true,
                                changes: {
                                    ...resp.Items[0],
                                    id: update.changes.id
                                }
                            }
                        );
                        this.store.dispatch(action);
                        throwError(
                            new DataServiceError(
                                resp.ErrorMessages.reduce(
                                    (a, c, i) => (i === 0 ? c : `${a}\n${c}`),
                                    ''
                                ),
                                { method: 'PUT', url: this.entitiesUrl }
                            )
                        );
                        throw new DataServiceError(
                            resp.ErrorMessages.reduce(
                                (a, c, i) => (i === 0 ? c : `${a}\n${c}`),
                                ''
                            ),
                            { method: 'PUT', url: this.entitiesUrl }
                        );
                    } else {
                        // invoice cycle can generate new items, with new Ids, so need to remove the old and add the new
                        if (update.changes.id !== resp.Items[0].id) {
                            const af = new EntityActionFactory();
                            const action = af.create(
                                this.entityName,
                                EntityOp.REMOVE_ONE,
                                update.changes.id
                            );
                            this.store.dispatch(action);
                        }
                        return resp.Items[0];

                        //     const ret = {
                        //         ...InvoiceContractCycle,
                        //         Status: {
                        //             StatusCode: ResponseStatus.Success,
                        //             Message: 'Saved'
                        //         }
                        //     } as InvoiceContractCycleModel;
                        //     const resUpd = resp.Items[0];
                        //     if (!resUpd) {
                        //         return update.changes as InvoiceContractCycleModel;
                        //     }
                        //     ret[resUpd.Calcdesc] = {
                        //         ...ret[resUpd.Calcdesc],
                        //         [resUpd.Loadingtype]: resUpd.LoadYesNo
                        //     };
                        //     this.log.verbose({
                        //         type: `${this.entityName}DataService(InvoiceContractCycleDataService):save:return`,
                        //         ret,
                        //         update,
                        //         resp: resp.Items
                        //     });
                        //     return ret;
                    }
                }),
                catchError((e, c) =>
                    fromShared.Errors.handleDataServiceError(this.store, e, c)
                )
            );
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
        this.usePostForQuery = true;
    }
}
